/**
 * Which observation states may be resubmitted (#986).
 *
 * This list MIRRORS the server's own gate — `observationRoutes.js` rejects anything else with a 400
 * ("Can only resubmit failed, cancelled, aborted, completed, or partially completed observations").
 * Offering the button for a state the server refuses produces an error the user cannot act on;
 * hiding it for a state the server accepts strands the observation, which is exactly what #986 was.
 *
 * Kept in one place because the copies drifted: the Observations page had been updated to include
 * `partially_completed` while both project views still tested
 * `status === 'completed' || status === 'failed'` inline — so the same observation could be
 * resubmitted from one screen and not another, and the project views additionally omitted
 * `cancelled` and `aborted`.
 *
 * `partially_completed` matters more than it looks: the run-until wind-down (#549) and the
 * constraint-stop-with-frames fix (#877) both deliberately land observations there instead of
 * failing them, and those are precisely the runs a user wants to re-run.
 */
export const RESUBMITTABLE_OBS_STATES = [
  'failed',
  'cancelled',
  'aborted',
  'completed',
  'partially_completed',
];

/** True when an observation in this state can be resubmitted. Tolerates null/undefined. */
export const canResubmitObservation = (status) => RESUBMITTABLE_OBS_STATES.includes(status);
